<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@200&family=Roboto:wght@300&display=swap" rel="stylesheet">

<!--  <button routerLink="manager">Manager Page</button>
<button routerLink="admin">Admin Page</button>
<button (click)="logout()">logout</button> -->

<app-page-content></app-page-content>
<!-- 
<div class ="content">
    <router-outlet></router-outlet>
</div> -->
<app-sticky-footer></app-sticky-footer>
